<div class="modal modal_size_744 modal_no-height modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">

    <div app-contact-item [contact]="contact" [showControls]="false"></div>

    <div class="modal__simple-field modal__simple-field-mb16 modal__simple-field-mt32">
      <span class="link link_with_arrow with-icon" (click)="edit()">{{ 'contact-info-modal.edit-contact' | translate }}</span>
    </div>
    <div class="modal__simple-field">
      <span class="link link_type_warning" (click)="delete()">{{ 'contact-info-modal.delete-contact' | translate }}</span>
    </div>
  </div>
</div>
